export default {
	name: 'SocialView'
}